"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _constants = require("../../constants");
var _PresenterSettingsMedia = require("./PresenterSettingsMedia.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _VideoJsPlayer = _interopRequireDefault(require("../VideoJsPlayer/VideoJsPlayer"));
var _underscore = require("underscore");
var _TranscodingState = require("../TranscodingState");
var PresenterSettingsMedia = function PresenterSettingsMedia(_ref) {
  var source = _ref.source;
  var value = source.value,
    title = source.title,
    type = source.type;
  var Component = /*#__PURE__*/_react["default"].createElement("img", {
    src: source.value.url,
    alt: title
  });
  switch (type) {
    case _constants.AUDIO_FILE:
      return /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia.MediaView, null, /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia.AudioPlaceholder, {
        icon: _freeSolidSvgIcons.faMusic
      }), /*#__PURE__*/_react["default"].createElement("audio", {
        src: value.url,
        controls: true
      }, "Your browser does not support the audio file"));
    case _constants.VIDEO_FILE:
      return /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia.MediaView, null, getVideoComponent(value));
    case _constants.MEDIA:
      return /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia.MediaView, null, /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia.IconWrapper, null, /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia.StyledIcon, {
        icon: _freeSolidSvgIcons.faPhotoVideo
      })));
    default:
      return /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia.MediaView, null, Component);
  }
};

/**
 * Returns a video component for the given value.
 * If the video is still processing (transcoding), displays the transcoding state.
 *
 * @param {object} value - The video source object, expected to have a `url` and optional `transcodingStatus`.
 * @returns {JSX.Element} The appropriate video player or transcoding state component.
 */
function getVideoComponent(value) {
  var transcodingStatus = (0, _underscore.isObject)(value) ? value.transcodingStatus : null;
  var isProcessingVideo = transcodingStatus && transcodingStatus !== 'success';

  /** show transcoding state when video file is processing*/
  if (isProcessingVideo) {
    return /*#__PURE__*/_react["default"].createElement(_TranscodingState.TranscodingState, {
      status: transcodingStatus
    });
  } else {
    var videoJsOptions = {
      controls: true,
      responsive: true,
      fill: true,
      autoplay: true,
      loadingSpinner: true,
      controlBar: {
        pictureInPictureToggle: false
      },
      preload: 'auto',
      playbackRates: [0.5, 1, 1.25, 1.5, 2]
    };
    return /*#__PURE__*/_react["default"].createElement(_VideoJsPlayer["default"], {
      options: videoJsOptions,
      videoUrl: value.url
    });
  }
}
PresenterSettingsMedia.propTypes = {
  source: _propTypes["default"].object
};
var _default = exports["default"] = PresenterSettingsMedia;